import { Box } from "@mui/material";
import React, { memo, useCallback, useState } from "react";
import SearchTextField from "../Search/SearchTextField";

interface FloatingSearchBarProps {
  initialValue: string;
  onSubmit: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
}

const FloatingSearchBar: React.FC<FloatingSearchBarProps> = memo(
  ({
    initialValue,
    onSubmit,
    onClear,
    placeholder = "Search facilities on the map... (Press Enter to search)",
  }) => {
    const [localValue, setLocalValue] = useState(initialValue);

    // Update local value when initial value changes (e.g., from URL)
    React.useEffect(() => {
      setLocalValue(initialValue);
    }, [initialValue]);

    const handleChange = useCallback((value: string) => {
      setLocalValue(value);
    }, []);

    const handleKeyPress = useCallback(
      (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
          onSubmit(localValue);
        }
      },
      [localValue, onSubmit]
    );

    const handleClear = useCallback(() => {
      setLocalValue("");
      onClear();
    }, [onClear]);

    return (
      <Box
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          right: 20,
          zIndex: 1000,
        }}
      >
        <SearchTextField
          value={localValue}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onClear={handleClear}
          placeholder={placeholder}
        />
      </Box>
    );
  }
);

FloatingSearchBar.displayName = "FloatingSearchBar";

export default FloatingSearchBar;
